// extracted by mini-css-extract-plugin
export default {"container":"totalValueTooltip_container__5eHmu","body":"totalValueTooltip_body__EJ8AL"};